"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const device_1 = require("@completeanatomy/device");
const PreferencesServiceProvider_1 = require("../../providers/PreferencesServiceProvider");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const hooks_1 = require("../../hooks");
const useIsPreferenceActive_1 = require("../../hooks/useIsPreferenceActive");
const types_1 = require("../../../service/types");
function Feature({ type, defaultSpoilerHeight = 100, children, className, }) {
    const [opened, setOpened] = (0, react_1.useState)(false);
    const isPushNotificationsActive = (0, hooks_1.usePushNotificationsState)() === types_1.PushNotificationsState.True;
    const isPreferenceActive = (0, useIsPreferenceActive_1.useIsPreferenceActive)(type);
    const isActive = type === bridge_schema_1.PreferenceBoolOption.PushNotifications
        ? isPushNotificationsActive
        : isPreferenceActive;
    const preferences = (0, PreferencesServiceProvider_1.usePreferencesService)();
    const { isMobile } = (0, device_1.usePlatform)();
    const bridge = (0, bridge_1.useBridge)();
    const descriptionRef = (0, react_1.useRef)(null);
    const [descriptionHeight, setDescriptionHeight] = (0, react_1.useState)(defaultSpoilerHeight);
    const onSpoilerToggle = () => {
        setOpened(prevState => !prevState);
        if (!opened) {
            const content = descriptionRef.current;
            const onTransitionEnd = () => {
                setDescriptionHeight(content.clientHeight);
                content.removeEventListener('transitionend', onTransitionEnd);
            };
            content.addEventListener('transitionend', onTransitionEnd);
        }
    };
    const onSwitchToggle = () => {
        if (type === bridge_schema_1.PreferenceBoolOption.PushNotifications) {
            try {
                bridge === null || bridge === void 0 ? void 0 : bridge.requestPushNotificationsPermissions();
            }
            catch (error) {
                console.error('Error setting push notifications:', error);
            }
        }
        preferences.toggle(type);
    };
    const i18NKey = getI18NKeyForType(type);
    const dict = i18n_1.Strings.settings.preferences.features[i18NKey];
    const name = dict && (0, i18n_1.Localized)(dict.name);
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'Feature_Container', children: [(0, jsx_runtime_1.jsxs)(Header, { "data-e2e": 'Feature_Header', children: [(0, jsx_runtime_1.jsx)(Name, { "data-e2e": 'Feature_Name', children: name }), isMobile && children && ((0, jsx_runtime_1.jsx)(InfoCircle, { onClick: onSpoilerToggle, "data-e2e": 'Feature_InfoCircle', children: (0, jsx_runtime_1.jsx)(InfoIcon, { name: ui_1.Icons.Info, selected: opened, "data-e2e": 'Feature_InfoIcon' }) })), (0, jsx_runtime_1.jsx)(FeatureSwitch, { onChange: onSwitchToggle, checked: isActive, "data-e2e": 'Feature_FeatureSwitch' })] }), (0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'Feature_Title', children: dict && (0, i18n_1.Localized)(dict.title) }), children && ((0, jsx_runtime_1.jsx)(Description, { "$isOpen": opened, "$height": descriptionHeight, ref: descriptionRef, "data-e2e": 'Feature_Description', children: children }))] }));
}
exports.Feature = Feature;
function getI18NKeyForType(type) {
    return {
        [bridge_schema_1.PreferenceBoolOption.ShowARPanel]: 'liveMode',
        [bridge_schema_1.PreferenceBoolOption.BeatingHeart]: 'beatingHeart',
        [bridge_schema_1.PreferenceBoolOption.Full3dRotation]: 'full3dRotation',
        [bridge_schema_1.PreferenceBoolOption.DarkTheme]: 'colorScheme',
        [bridge_schema_1.PreferenceBoolOption.ShowHub]: 'hub',
        [bridge_schema_1.PreferenceBoolOption.PrivacyNotifications]: 'privacyNotifications',
        [bridge_schema_1.PreferenceBoolOption.PushNotifications]: 'pushNotifications',
        [bridge_schema_1.PreferenceBoolOption.AutoSync]: 'autoSync',
        [bridge_schema_1.PreferenceBoolOption.ShowModelUpdatesIndicators]: 'modelUpdates',
        [bridge_schema_1.PreferenceBoolOption.ShowSafeGuides]: 'safeGuides',
    }[type];
}
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
const Header = styled_components_1.default.div `
  display: flex;
  align-items: center;

  margin-bottom: 12px;
`;
const Name = styled_components_1.default.span `
  color: ${({ theme }) => theme.designSystem.text};
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const InfoCircle = styled_components_1.default.button `
  flex-shrink: 0;
  box-sizing: border-box;
  width: 21px;
  height: 20px;
  margin-left: 8px;

  padding: 0;

  color: ${({ theme }) => theme.designSystem.text};

  background-color: transparent;
  border: none;
`;
const InfoIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 100%;
  height: 100%;
`;
const FeatureSwitch = (0, styled_components_1.default)(ui_1.Switch) `
  margin-right: 6px;
  margin-left: auto;
`;
const Title = styled_components_1.default.span `
  font-style: italic;
`;
const Description = styled_components_1.default.span `
  max-height: ${({ $isOpen, $height }) => ($isOpen ? `${$height}px` : '0px')};
  margin-top: ${({ $isOpen }) => ($isOpen ? '12px' : '0')};

  overflow: hidden;

  color: ${({ theme }) => theme.designSystem.textSecondary};

  transition: max-height 0.5s linear, margin-top 0.5s linear;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    max-height: unset;
    margin-top: 12px;
  `)}
`;
